<template>
    <v-card class="mb-6 mr-4">
        <v-card-title>
            <div v-if="with_name" class="mr-4">{{ group.name }}</div>
        </v-card-title>
        

        <v-card-text v-if="group.type">
            {{ group.type == 'accessory' ? 'Комплектующая' : 'Продукт'}}
            </v-card-text>
    </v-card>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "SubGroup",
    props: ["group", "with_name", "edited", "plan", "fact", "small", "_id", 'status', 'input'],
    data: () => ({
        dialog: false,
        accessories_dialog: false,
        name: null,
        image: null,
        sub_group: null,
        ratio: 10,
        accessories: [],
        items: [
            {
                name: "1 подгруппа",
                value : 'А'
            },
            {
                name: "2 подгруппа",
                value : 'Б'
            },
            {
                name: "3 подгруппа",
                value : 'В'
            },
            {
               name: "4 подгруппа",
                value : 'Г'
            },
            {
               name: "5 подгруппа",
                value : 'Д'
            },
            {
                name: "6 подгруппа",
                value : 'Е'
            },
            {
                name: "7 подгруппа",
                value : 'Ж'
            },
            {
                name: "8 подгруппа",
                value : 'З'
            },
            {
                name: "9 подгруппа",
                value : 'И'
            },
            {
                name: "10 подгруппа",
                value : 'К'
            }
        ]
    }),
    components: {
        
    },
    computed: {
        ...mapGetters(["get_accessories", "get_original_products", "get_baseURL"]),
    },
    methods: {
        ...mapActions(["create_product", "add_image"]),
        save() {
            if (!this.name || !this.image) return false;
            this.upload_image();
        },
        async upload_image() {
            let formData = new FormData();
            formData.append("file", this.image);

            const instance = await axios.create({
                baseURL: this.get_baseURL,
                headers: {
                "Content-Type": "multipart/form-data",
                Authorization: localStorage.getItem("_token"),
                },
            });

            instance
                .post(`/original_products/image`, formData)
                .then((response) => response.data)
                .then((data) => {
                    this.create_product({
                        name: this.name,
                        image: data.name,
                        ratio: this.ratio,
                        accessories: this.accessories,
                        group_id: this.group._id,
                        sub_group: this.sub_group
                    });
                    this.name = null;
                    this.image = null;
                    this.ratio = null;
                    this.accessories = [];
                    this.dialog = false;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {});
        },

        add_accessory(accessory) {
            this.accessories.push(accessory);
            this.accessories_dialog = false;
        },
    },
};
</script>

<style scoped>
.accessory {
  display: flex;
  align-items: center;
}

.accessory img {
  object-fit: contain;
  max-height: 200px;
  max-width: 200px;
}

.accessory text {
  font-size: 40px;
  margin: 0 20px;
}

.accessory input {
  font-size: 52px;
  max-width: 70px;
  padding: 0px 5px 0 20px;
  border-bottom: 1px solid;
}
</style>